<template>
  <div>
    <popup-add-email-template ref="popupAddAutomation" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <p>
          E-mail templates can be used in automations. They are automatically adapted to sender venue and
          receiving guest.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            type="relief"
            color="primary"
            v-if="hasPermission('vp.crm.emailtemplates.edit')"
            @click="$refs.popupAddAutomation.show()"
            >Create new</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        max-items="50"
        class="mt-8"
        v-model="selected"
        pagination
        search
        :data="emailTemplates"
        @selected="onClicked(selected.id)"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Preview</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="category">Category</vs-th>
          <vs-th sort-key="enabled">Enabled</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="previewImageWrapper" @click.native.stop.prevent>
                  <img
                    @click.stop.prevent
                    v-img:emailTemplate
                    class="previewImage rounded-lg"
                    v-if="tr.previewImage"
                    :src="tr.previewImage"
                  />
                </div>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.name }}
                </p>
              </vs-td>
              <vs-td>
                {{ tr.type }}
              </vs-td>
              <vs-td>
                <vs-chip color="primary">
                  {{ tr.category || "Uncategorized" }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip :color="tr.enabled | yesnocolor">
                  {{ tr.enabled | yesno }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupAddEmailTemplate from "./PopupAddEmailTemplate.vue";
export default {
  components: { PopupAddEmailTemplate },
  data() {
    return {
      newMessageTitle: "",
      selected: [],
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "crm-email-template",
          params: { id: id },
        })
        .catch(e => {
          console.log("EmailTemplate lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      emailTemplates: "emailTemplates/emailTemplates",
    }),
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("emailTemplates/getAll");
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
.previewImageWrapper {
  height: 80px;
  width: 100px;
  overflow: hidden;
  border-radius: 8px;

  .previewImage {
    height: 80px;
    width: 100px;
    transform: scale(1.2) translateY(8px);
    object-fit: cover;
  }
}
</style>